export const DEFAULT_LANDING_PAGE = "/userzone";

export default {
  DEFAULT_LANDING_PAGE,
};
